import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../../app/api";
import { SIDE_PADDING, TOP_PADDING } from "../../../app/theme/muiTheme";
import DebateCard from "../../common/DebateCard";
import Footer from "../../common/Footer";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    paddingTop: TOP_PADDING,
    paddingBottom: TOP_PADDING,
    minHeight: "60vh",
    backgroundColor: theme.palette.primary.light,
  },
}));

const Debates = (props) => {
  const classes = useStyles();

  const [debatesList, setDebatesList] = useState([]);

  const fetchDebates = useCallback(async () => {
    try {
      const { data } = await api.withoutAuth.get("/debates");
      setDebatesList(data.message || []);
    } catch (error) {
      console.log(error);
    } finally {
    }
  }, [setDebatesList]);

  useEffect(() => {
    fetchDebates();
  }, [fetchDebates]);

  return (
    <>
      <div className={classes.root}>
        <Grid container justifyContent={"space-between"}>
          <Grid item xs={12}>
            <Typography>Debates</Typography>
          </Grid>
          {debatesList.map((item, index) => {
            return <DebateCard key={index} data={item} />;
          })}
        </Grid>
      </div>
      <Footer />
    </>
  );
};

export default Debates;
